import { render, staticRenderFns } from "./store-item.vue?vue&type=template&id=4a66f764&scoped=true"
import script from "./store-item.vue?vue&type=script&lang=js"
export * from "./store-item.vue?vue&type=script&lang=js"
import style0 from "./store-item.vue?vue&type=style&index=0&id=4a66f764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a66f764",
  null
  
)

export default component.exports